"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
import { useAuthFlow } from "./auth-flow-context";
import { AuthMethodId } from "./types";
export interface MethodSwitchProps {
  to: AuthMethodId;
  label: string;
  className?: string;
}
export function MethodSwitch(t0) {
  const $ = _c(9);
  const {
    to,
    label,
    className
  } = t0;
  const {
    state,
    actions
  } = useAuthFlow();
  if (state.activeMethod === to) {
    return null;
  }
  let t1;
  if ($[0] !== actions || $[1] !== to) {
    t1 = () => actions.setActiveMethod(to);
    $[0] = actions;
    $[1] = to;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className) {
    t2 = cx("text-body-strong text-link", "transition-colors duration-200", "hover:text-link-hover", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== label || $[6] !== t1 || $[7] !== t2) {
    t3 = <div className="mt-4 text-center sm:mt-6"><button type="button" onClick={t1} className={t2}>{label}</button></div>;
    $[5] = label;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}